export enum ActionTypes {
  GetEmailApiUsage = 'getEmailApiUsage',
  GetEmailApiUsageRequest = 'getEmailApiUsage.request',
  GetEmailApiUsageSuccess = 'getEmailApiUsage.success',
  GetEmailApiUsageFailure = 'getEmailApiUsage.failure',
}
